(function () {
    'use strict';

    const module = angular.module('uwAgenda.users');
    module.directive('userContactInfo', ['$rootScope', '$translate', '$timeout', 'UserContactinfoType', 'UserBroadcast', 'HelperService', 'SharedAgendaService', 'Alert', 'UserContactInfoTypeEnum', UserContactInfoFn]);

    /* display a user contact info */
    function UserContactInfoFn($rootScope, $translate, $timeout, UserContactinfoType, UserBroadcast, HelperService, SharedAgendaService, Alert, UserContactInfoTypeEnum) {

        const directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-contact-info.template.html',
            scope: {
                contactInfo: '=',
                readonly: '@?',
                contactInfos: '=?',
                deleteable: '@?', // is contact-info deleteable -> default true
                selectableCheckbox: '@?', // selectable contact-info for new-appointment
                selectableFn: '&?', // callback after select was made
                captionReadonly: '@?', // is user allowed to edit caption or not
                onlyCaption: '@?' // show only caption, no number                 
            }
        };
        return directive;

        function link(scope, element, attrs) {
            let timeouter = null;

            // activate
            activate();
            scope.getCaptionTranslated = function (type) {
                const captions = {
                    1: "phone",
                    2: "mobile",
                    3 : "email",
                    4: "Fax",
                    5: "website"
                };
                return $translate.instant(captions[type]);
            };

            /* set new calling code */
            function selectCountry(country) {
                if (!country) { return; }
                scope.currentCountry = country;
                scope.contactInfo.prefix = country.callingCode;
                scope.$broadcast(UserBroadcast.ContactInfoCountryChanged);
            }

            /* show country calling code list ? */
            function showCountryCallingCode() {
                scope.show = false;
                if (!scope.contactInfo.userContactInfoType) { return; }
                if (scope.contactInfo.prefix === null) { return; }
                if (scope.contactInfo.userContactInfoType.type === UserContactInfoTypeEnum.Phone.value
                    || scope.contactInfo.userContactInfoType.type === UserContactInfoTypeEnum.Mobile.value
                    || scope.contactInfo.userContactInfoType.type === 4) { //fax
                    scope.show = true;
                }
            }


            // activation work
            function activate() {
                if (typeof scope.contactInfo === 'undefined') { return; }
                scope.readonly = scope.readonly && scope.readonly === 'true' ? true : false;
                scope.onlyCaption = scope.onlyCaption && scope.onlyCaption === 'true' ? true : false;


                // make right ci-type object
                const cit = new UserContactinfoType();
                cit.extend(scope.contactInfo.userContactInfoType);
                scope.contactInfo.userContactInfoType = cit;

                // type of activation
                if (scope.readonly === false) {
                    activateEditable();
                } // if
                else {                    
                    scope.immediate = attrs.immediate !== undefined ? true : false;
                    scope.notDialable = attrs.notdialable !== undefined ? true : false;
                }

            } // activate


            // editable activation work 
            function activateEditable() {
                const elm = element.children().find("#contactinfo");
                // get focus on input field
                timeouter = $timeout(function () {
                    elm.focus();
                }, 0);

                if (typeof scope.selectableCheckbox !== 'undefined' && scope.selectableCheckbox === 'true') {
                    scope.selectableCheckbox = true;
                } // if

                // by default not readonly
                scope.captionReadonly = scope.captionReadonly && scope.captionReadonly === 'true' ? true : false;

                // deletable
                if (typeof scope.deleteable === 'undefined') { scope.deleteable = true; }
                else { scope.deleteable = false; }

                // set in scope 
                scope.isRingfoon = $rootScope.isRingfoon;

                // show country calling code
                showCountryCallingCode();

                if (scope.show) {

                    // set countries (calling-code ones)
                    scope.countries = HelperService.data.countriesWithCallingCodes;
                    // prepare img icon path
                    const imgPath = $rootScope.settings.globalPath + '/img/flags/';

                    // set img icon and current country
                    let i = 0;
                    const len = scope.countries.length;
                    for (i = 0; i < len; i++) {
                        const item = scope.countries[i];
                        if (item.shortCut) {
                            item.icon = imgPath + item.shortCut.trim().toLowerCase() + '.png';
                        } // if
                        // is actual country ?
                        if (scope.contactInfo.prefix === item.callingCode) {
                            scope.currentCountry = item;
                            scope.contactInfo.prefix = item.callingCode;
                        } // if
                    } // for                  

                    // set calling code if null
                    if (!scope.currentCountry) {
                        // set Belgium as the default selected country
                        let countryBelgium = scope.countries.filter(function(country) {
                            return country.shortCut === 'BE';
                        })[0];

                        let selectedCountry = countryBelgium || scope.countries[0];                        

                        // if user has a country, set the prefix for this country by default
                        SharedAgendaService.isLoading().then(function () {
                            const userCountryId = SharedAgendaService.currentUser().countryId;
                            if (userCountryId > 0) {
                                for (i = 0; i < scope.countries.length; i++) {
                                    if (scope.countries[i].id === userCountryId) {
                                        selectedCountry = scope.countries[i];
                                        break;
                                    }
                                }
                            }

                            selectCountry(selectedCountry);
                        });
                    } // if
                }// if
            } // activateEditable


            /* delete a contact info */
            scope.deleteContactInfo = function () {
                if (typeof scope.contactInfos === 'undefined') { return; }
                // delete item from array
                scope.contactInfos.splice(scope.contactInfos.indexOf(scope.contactInfo), 1);
            };

            // public functions
            scope.selectCountry = selectCountry;

            scope.copyToClipboard = function () {
                HelperService.copyTextToClipboard(scope.contactInfo.contactInfo);

                const confirmation = $translate.instant('value_copied', { value: scope.contactInfo.contactInfo});
                Alert.info(confirmation);
            };        

            // destroy
            scope.$on("$destroy", function () {
                $timeout.cancel(timeouter);
                timeouter = null;
            });

        }
    }
})();